import * as React from 'react';

export interface AnimateProps {
  animateClasses?: string;

  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;

  /** Any node to render to animate. */
  children: React.ReactNode;

  /** A callback fired immediately after the transition starts.*/
  onStart?(): void;

  /** A callback fired immediately after the transition ended.*/
  onEnd?(): void;

  /** set a delay before the animation execution. When provided a number- sets this as `ms`.*/
  delay?: AnimateDelay;

  /** Add inline styles to the animation */
  animateInlineStyle?: React.CSSProperties;
}

export type AnimateDelay = string | number | undefined;
